import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '../app-services';
import { Title } from '@angular/platform-browser';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { MpHeaderComponent } from '../mp-header/mp-header.component';
import { MpFooterComponent } from '../mp-footer/mp-footer.component';

@Component({
  selector: 'main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MpHeaderComponent, RouterOutlet, MpFooterComponent],
})
export class MainComponent implements OnInit {
  protected authService = inject(AuthService);
  protected router = inject(Router);
  private readonly titleService = inject(Title);
  private readonly translateService = inject(TranslateService);

  ngOnInit() {
    const env = environment.name === 'test';
    const credentials = this.authService.credentials;
    if (!credentials) {
      return;
    }
    const role = credentials.payload.role;
    const roleTitleKeyByRole: Record<string, string> = {
      ADMIN: 'login-scope-admin',
      SUPER_ADMIN: 'login-scope-super-admin',
      MODEL_ADMIN: 'login-scope-model-admin',
    };
    const roleKey = roleTitleKeyByRole[role] ?? role;
    const translatedRole = this.translateService.instant(roleKey);
    this.titleService.setTitle(`${env ? 'Test - ' : ''} Magic cut (${translatedRole})`);

    if (this.router.url === '/') {
      const paths: Record<string, string> = {
        ADMIN: '/users-management',
        SUPER_ADMIN: '/admin-management',
        MODEL_ADMIN: '/printable-data-management',
      };

      this.router.navigate([paths[role]]);
    }
  }
}
